import gql from 'graphql-tag';

export const EXPORT_USERS = gql`
  query ($projectId: String!, $dateFrom: DateTime, $dateTo: DateTime, $fileType: FileType,$ianaTimeZone:String!) {
    report {
      exportGroupUsers(projectId: $projectId, dateFrom: $dateFrom, dateTo: $dateTo, fileType: $fileType,ianaTimeZone:$ianaTimeZone) {
        contentType
        s3Key
      }
    }
  }
`;
